import { format } from "date-fns";
import { getDoc, doc, setDoc } from "firebase/firestore";
import resolveDb from "../db";
import {
	DbInstance,
	LICENSE,
	LICENSE_EXPIRATION_DATE,
} from "../utils/constants";
import { firestoreDb } from "../firebase";
import isAfter from "date-fns/isAfter";

const db = resolveDb(DbInstance.JSON_DB);

export async function checkLicense() {
	const result = await db.get(LICENSE_EXPIRATION_DATE);

	return format(new Date(result as string), "Pp");
}

export async function refreshLicense() {
	const license = await db.get(LICENSE);
	const currentExpirationDate = await db.get(LICENSE_EXPIRATION_DATE);
	const licenseData = (
		await getDoc(doc(firestoreDb, "code_requests", license as string))
	).data();

	const validLicense = Boolean(
		licenseData &&
			!licenseData?.validated &&
			!licenseData?.used &&
			licenseData?.expirationDate
	);

	if (!validLicense) {
		return Promise.reject("Unable to refresh the license");
	}

	const dateString = format(licenseData?.expirationDate.toDate(), "Pp");
	const expirationDate = new Date(dateString);
	const validLicenseDate = isAfter(
		expirationDate,
		new Date(currentExpirationDate as string)
	);

	if (!validLicenseDate) {
		return Promise.reject("Unable to refresh the license");
	}

	await setDoc(
		doc(firestoreDb, "code_requests", license as string),
		{ validated: true },
		{ merge: true }
	);
	await db.create(dateString, LICENSE_EXPIRATION_DATE, {
		avoidUUID: true,
	});

	return format(expirationDate, "Pp");
}
